import { ChangeEvent, useContext, useEffect, useState } from "react";
import { TestContext } from "../store/testContext";
import { changeMinCorrectAnswersCount } from "../store/testActions";

export default function MinCorrectAnswers() {
  const {
    dispatch,
    state: { Questions, MinCorrectAnswersCount }
  } = useContext(TestContext);

  const initialCorrectAnswersCount = MinCorrectAnswersCount || Questions.length;
  const [countCorrectAnswers, setCountCorrectAnswers] = useState(initialCorrectAnswersCount);

  useEffect(() => {
    setCountCorrectAnswers(Questions.length);
    dispatch(changeMinCorrectAnswersCount(Questions.length));
  }, [Questions.length]);

  const changeMinCorrectAnswer = (e: ChangeEvent<HTMLSelectElement>) => {
    const newCount = +e.target.value;
    setCountCorrectAnswers(newCount);
    dispatch(changeMinCorrectAnswersCount(newCount));
  };

  if (!Questions.length) return null;

  return (
    <div>
      <p className="my-[10px] text-black text-base font-normal">Необходимое количество правильных ответов для успешного прохождения теста</p>
      <select onChange={changeMinCorrectAnswer} value={countCorrectAnswers} className="w-full rounded-md shadow-custom mb-5 border-[#DFE4EA] focus:border-[#DFE4EA]">
        {Questions.map((_, index) => (
          <option key={index + 1} value={index + 1}>
            {index + 1}
          </option>
        ))}
      </select>
    </div>
  );
}
